import { render, staticRenderFns } from "./ShareGroup.vue?vue&type=template&id=dddaf7ba&scoped=true&"
import script from "./ShareGroup.vue?vue&type=script&lang=js&"
export * from "./ShareGroup.vue?vue&type=script&lang=js&"
import style0 from "./ShareGroup.vue?vue&type=style&index=0&id=dddaf7ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddaf7ba",
  null
  
)

export default component.exports